@if (notificationsLoaded) {
  <mat-accordion>
    @for (n of notifications; track n) {
      <mat-expansion-panel
        class="notifications-list-expansion-panel"
        [ngClass]="{
            'notification-unread': n.readAt == null && !expPanel.expanded
        }"
        hideToggle="true"
        (opened)="ngOnInit()"
        #expPanel
        >
        <mat-expansion-panel-header
          (click)="onClickMarkAsRead(n)"
          [ngClass]="{ 'notification-expanded': expPanel.expanded }"
          >
          <div fxFlex="100">
            <div class="panel-header-text" fxLayout="row">
              <span class="with-icon"
                >@if (n.type == 'announcement') {
                <mat-icon
                  aria-label="Announcements"
                  >announcement
                </mat-icon>
              }
              @if (n.type == 'pm') {
                <mat-icon aria-label="Messages"
                  >messages</mat-icon
                  >
                }
                <span>{{ n.title }}</span></span
                >
                <span class="fill-remaining-space"></span>
                <span class="date-sent" fxShow.gt-sm>{{
                  formatDate(n.createdAt)
                }}</span>
              </div>
              @if (!expPanel.expanded) {
                <div
                  class="more-button"
                  fxLayout="row"
                  >
                  <span class="fill-remaining-space"></span>...more...
                </div>
              }
            </div>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div fxLayout="row wrap" fxLayoutGap.gt-xs="10px">
              <section fxFlex="100" fxFlex.lt-sm="100" fxLayoutGap="10px">
                <div class="from">
                  <span class="from-key">From</span
                    ><span class="from-value">{{ n.authorName }}</span>
                  </div>
                  <div>
                    <p><span [innerHTML]="n.body"></span></p>
                  </div>
                </section>
              </div>
              @if (n.replies.length > 0) {
                <div>
                  <div class="recent-reply">Most Recent Reply</div>
                  <div [innerHTML]="n.replies[0].body"></div>
                </div>
              }
              @if (!replyWindowOpen) {
                <mat-action-row fxLayout="row">
                  @if (replyButtonPresence(n)) {
                    <button
                      mat-raised-button
                      color="primary"
                      (click)="onClickReplyToMessage()"
                      [disabled]="n.archivedAt"
                      >
                      <span class="with-icon"
                        ><mat-icon aria-label="Reply">reply</mat-icon
                        >Reply</span
                        >
                      </button>
                    }
                    @if (!n.archivedAt) {
                      <button
                        matTooltip="Move to Archived"
                        mat-raised-button
                        (click)="onClickMarkAsArchived(n)"
                        class="icon-only"
                        >
                        <mat-icon
                          aria-label="Archive"
                          [ngStyle]="{ color: '#7f8c8d', 'font-size': '18px' }"
                          [inline]="true"
                          fontSet="fa"
                          fontIcon="fa-archive"
                        ></mat-icon>
                      </button>
                    }
                    @if (n.archivedAt) {
                      <button
                        matTooltip="Move to Inbox"
                        mat-raised-button
                        (click)="onClickRestore(n)"
                        class="icon-only"
                        >
                        <mat-icon aria-label="Restore">restore</mat-icon>
                      </button>
                    }
                  </mat-action-row>
                }
                @if (replyWindowOpen) {
                  <div class="reply-window" fxLayout="column">
                    <div class="recent-reply">Your Reply</div>
                    <reply-pm
                      [notification]="n"
                      (reply)="sendReply($event)"
                      (cancel)="onClickCancelReply()"
                    ></reply-pm>
                  </div>
                }
              </ng-template>
            </mat-expansion-panel>
          }
        </mat-accordion>
      }
